module.exports = __webpack_public_path__ + "static/mobile-fd2c419c419bda02d49ec954cc34410e.jpg";